
import { create } from "zustand";
type RolePermission = {
      role: "user" | string; // If role can be dynamic, keep `string`

      permissions: {
            applications: {
                  changeStatus: number[];
                  comment: boolean;
                  create: boolean;
                  downloadPDF: boolean;
                  edit: boolean;
                  manage: boolean;
                  view: boolean;
                  visibleAtStatus: number[];
                  cancelApplicationByApi: boolean;
                  profileUpdate: {
                        edit: boolean;
                  },
                  showExamExemptedConsent: boolean;
            };
            files: {
                  view: boolean,
                  create: boolean,
                  edit: boolean,
                  manage: boolean,
                  maxSize: number
            };
            payments: {
                  applicationFee: boolean;
                  seatBooking: boolean;
                  moduleFee: boolean;
                  verify: boolean;
                  internationalPayment: boolean;
            };

            paymentsHistory: {
                  view: boolean;
            };

            moduleRegistration: {
                  viewModules: boolean;
                  addDrop: boolean;
            };

            modules: {
                  view: boolean;
                  create: boolean;
                  edit: boolean;
                  manage: boolean;
            };

            bulkOperations: {
                  verifier: {
                        updateVerifier: boolean;
                  }
            },

            statusManagement: {
                  view: boolean;
                  create: boolean;
                  edit: boolean;
                  manage: boolean;
                  visibleStatuses: number[];
            };

            users: {
                  view: boolean;
                  create: boolean;
                  edit: boolean;
            };

            lmsIntegration: {
                  pushEnrollment: boolean;
            };
            userSettings: {
                  currency: {
                        value: string | number | null;
                        editable: boolean;
                  };
            };
            analytics:{
                  view: boolean;
            };
            changeLogs:{
                  view: boolean;
            }; 
      };
};

type RolePermissionStore = {
      rolePermission: RolePermission | null;
      setRolePermission: (data: RolePermission) => void;
      getPermission: <K extends keyof RolePermission["permissions"]>(
            section: K
      ) => RolePermission["permissions"][K] | null;
};

export const useRolePermissionStore = create<RolePermissionStore>((set, get) => ({
      rolePermission: null,
      setRolePermission: (data) => set({ rolePermission: data }),
      getPermission: (section) => {
            const state = get().rolePermission;
            if (!state) return null;
            return state.permissions[section];
      },
}));